import { inject, Injectable } from '@angular/core';
import { MarketWidget } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { tap } from 'rxjs/operators';
import { MarketDashboardSignalStore } from '../+state/market-dashboard-signal.store';
import { MarketWidgetDataService } from '../infrastructure/widget.data.service';

@Injectable()
export class WidgetMutationFacade {
  private service = inject(MarketWidgetDataService);
  private store = inject(MarketDashboardSignalStore);

  add$(input: MarketWidget) {
    return this.service.add$(input).pipe(
      tap((value: MarketWidget) => {
        const storedWidget = {
          ...input,
          id: value.id,
        };

        this.store.upsertWidget(storedWidget);
      }),
    );
  }

  update$(input: MarketWidget) {
    return this.service
      .update$(input)
      .pipe(tap(() => this.store.upsertWidget({ ...input })));
  }

  delete$(id: ID) {
    return this.service
      .delete$(id)
      .pipe(tap(() => this.store.removeWidget(id)));
  }
}
